import { styled } from "@mui/material";
export const Wrap = styled("div")(() => ({
    width: "100%",
}));
export const WrapTitle = styled("div")(() => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
}));
export const BaseCarousel = styled("div")(({ hasArrows }) => ({
    position: "relative",
    paddingLeft: hasArrows ? "48px" : "0px",
    paddingRight: hasArrows ? "48px" : "0px",
}));
export const SliderStyled = styled("div")(() => ({
    "& .slick-list": {
        padding: "20px 0px 40px 0px",
        overflow: "hidden",
        "& div": {
            margin: "auto",
        },
    },
}));
export const CustomPagingStyled = styled("div")(({ currentSlide }) => ({
    width: "10px",
    height: "10px",
    color: "blue",
    backgroundColor: currentSlide
        ? "var(--color-primary)"
        : "var(--color-grey-10)",
    border: `1px solid ${currentSlide ? "var(--color-primary)" : "#E5E7EB"}`,
    borderRadius: "25px",
    marginTop: "-20px",
    "&:hover": {
        border: "2px solid var(--color-primary)",
    },
}));
export const IconButtonleft = styled("div")(() => ({
    position: "absolute",
    top: "calc(50% - 15px)",
    left: 0,
    "& svg": {
        fontSize: "14px",
    },
}));
export const IconButtonRight = styled("div")(() => ({
    position: "absolute",
    top: "calc(50% - 15px)",
    right: 0,
    "& svg": {
        fontSize: "14px",
    },
}));
